module.exports = __webpack_public_path__ + "img/14.b57afde7.png";